

















import { DateTime } from 'luxon'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    song: Object
  }
})
export default class ProgramSection extends Vue {
  formatDate (date: number): string {
    return DateTime.fromMillis(date).toFormat('HH:mm')
  }
}
